import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class EmpleoService {

  constructor(private http: HttpClient) { }

  getestadocivil() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/estadocivil`);
  }

  getestatusacademico() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/estatusacademico`);
  }

  getgiroempresa() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/giroempresa`);
  }

  getnivelacademico() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/nivelacademico`);
  }

  getotrosestudios() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/otrosestudios`);
  }

  getperfil(id: number) {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/perfil?id=${id}`);
  }

  getsexo() {
    return this.http.get(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/sexo`);
  }

  UploadImage(file: File) {
    var formData = new FormData();
    formData.append('file', file);
    return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/UploadFile`, formData, {
        headers: {
            'Accept': 'application/json'
        }
    })
  }

  postPostulante(postulante: any){
    return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/postulante`, postulante, {
      headers: {
          'Accept': 'application/json'
      }
    })
  }
  postDomicilio(domicilio: any){
    return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/domicilio`, domicilio, {
      headers: {
          'Accept': 'application/json'
      }
    })
  }
  postAcademico(academico: any){
    return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/Academico`, academico, {
      headers: {
          'Accept': 'application/json'
      }
    })
  }
  postExperiencia(experiencia: any){
    return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/Experiencia`, experiencia, {
      headers: {
          'Accept': 'application/json'
      }
    })
  }
  postOtrosEstudios(OtrosEstudios: any){
    return this.http.post(`https://fundacionbest.org.mx/Webapi/best/api/Empleo/OtrosEstudios`, OtrosEstudios, {
      headers: {
          'Accept': 'application/json'
      }
    })
  }
}
